import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { PUBLISH_FORM, PUBLISH_SUCCESS } from 'FormsUI/constants/TrackingInteractionKeys/Editor/Global';
import { hasRequiredTicketFields as getHasRequiredTicketFields, getFormFields
// @ts-expect-error types missing
} from 'FormsUI/selectors/FormDefinition';
import { getHasMultiplePaymentLinks, getHasSinglePaymentLink
// @ts-expect-error types missing
} from 'FormsUI/selectors/Payments';
import { getIsV3Form } from 'FormsUI/selectors/EmbedCode';

// @ts-expect-error types missing
import getCustomLifecycleStage from 'FormsUI/selectors/formDefinition/getCustomLifecycleStage';
import getFlows from 'ui-forms-editor-automation-lib/selectors/flows/getFlows';
import { getNumberOfPoliciesFromRouting, getNumberOfListsFromRouting, getIsRoutingEnabled, getRouteTypesFromRouting } from 'FormsUI/utils/Routing';
import { ROUTE_STATE } from 'FormsUI/constants/Routing';
import trackUsage from 'FormsUI/actions/TrackUsage/trackUsage';
import { getPostSubmissionOption, getDefinition
// @ts-expect-error types missing
} from 'FormsUI/selectors/FormDefinition';
import { getPublishExtraJson } from 'FormsUI/utils/FormSavingUtils';
export const trackFormPublishSuccess = formRouting => (dispatch, getState) => {
  const state = getState();
  const flows = getFlows(state);
  const definition = getDefinition(state);
  const postSubmitOption = getPostSubmissionOption(state);
  const hasRequiredTicketFields = getHasRequiredTicketFields(state);
  const hasCustomLifecycleStage = getCustomLifecycleStage(state);
  const hasMultiplePaymentLinks = getHasMultiplePaymentLinks(state);
  const hasSinglePaymentLink = getHasSinglePaymentLink(state);
  const isV3Form = getIsV3Form(state);
  const formFields = getFormFields(state);
  const hasHiddenFields = formFields.some(field => field.hidden);
  const hasSimpleWorkflows = flows ? Boolean(flows.length) : false;
  const hasSimpleWorkflowsOn = Boolean(flows.find(i => i.isEnabled));
  const isRoutingEnabled = formRouting && getIsRoutingEnabled(formRouting);
  const numberOfRoutingConditions = isRoutingEnabled && getNumberOfListsFromRouting(formRouting);
  const numberOfRoutingFields = isRoutingEnabled && getNumberOfPoliciesFromRouting(formRouting);
  const hasConditionalRouting = isRoutingEnabled && formRouting.routeState === ROUTE_STATE.CONDITIONAL_ROUTE;
  const conditionalMeetingRoutes = hasConditionalRouting && getRouteTypesFromRouting(formRouting);
  const hasSimpleRouting = isRoutingEnabled && formRouting.routeState === ROUTE_STATE.SIMPLE_ROUTE;
  const {
    hasConsent,
    hasDependentFields,
    hasDefaultStyling,
    hasQueuedFields,
    hasSmartFields,
    hasChangedDefaultStyles,
    hasSimpleRedirects,
    hasTranslation
  } = getPublishExtraJson(definition, postSubmitOption);
  const hasOptions = [...(hasHiddenFields ? ['hasHiddenFields'] : []), ...(hasRequiredTicketFields ? ['hasTicketProperties'] : []), ...(hasCustomLifecycleStage ? ['hasCustomLifecycleStage'] : []), ...(hasSimpleWorkflows ? ['hasSimpleWorkflows'] : []), ...(hasSimpleWorkflowsOn ? ['hasSimpleWorkflowsOn'] : []), ...(hasSinglePaymentLink ? ['hasSinglePaymentLink'] : []), ...(hasMultiplePaymentLinks ? ['hasMultiplePaymentLinks'] : []), ...(isV3Form ? ['isV3Form'] : []), ...(hasConditionalRouting ? ['hasConditionalRouting'] : []), ...(hasSimpleRouting ? ['hasSimpleRouting'] : []), ...(hasConsent ? ['hasConsent'] : []), ...(hasDependentFields ? ['hasDependentFields'] : []), ...(hasDefaultStyling ? ['hasDefaultStyling'] : []), ...(hasQueuedFields ? ['hasProgressiveFields'] : []), ...(hasSmartFields ? ['hasSmartFields'] : []), ...(hasChangedDefaultStyles ? ['hasCustomStyling'] : []), ...(hasSimpleRedirects ? ['hasSimpleRedirects'] : []), ...(hasTranslation ? ['hasTranslation'] : [])];
  const options = Object.assign({}, hasHiddenFields ? {
    hasHiddenFields: true
  } : {}, hasRequiredTicketFields ? {
    hasTicketProperties: true
  } : {}, hasSimpleWorkflows ? {
    hasSimpleWorkflows: true,
    withSimpleWorkflowsOn: hasSimpleWorkflowsOn ? 'yes' : 'no'
  } : {}, hasCustomLifecycleStage ? {
    hasCustomLifecycleStage: true
  } : {}, isRoutingEnabled ? {
    isRoutingEnabled,
    numberOfRoutingConditions,
    numberOfRoutingFields,
    routeType: formRouting.routeState
  } : {}, hasConditionalRouting ? {
    conditionalMeetingRoutes
  } : {}, {
    value: [...hasOptions, `fieldCount: ${formFields.length}`]
  });
  dispatch(trackUsage(PUBLISH_SUCCESS, options));
  trackEditorInteraction(PUBLISH_FORM);
  trackEditorInteraction(PUBLISH_SUCCESS, options);
};
export default trackFormPublishSuccess;